export const FLEXIBLE_TEXT_CONTAINTER_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.FlexibleTextContainerElement';
